import { useParams } from 'react-router-dom';
import CampaignForm from '@/pages/ads/CampaignForm.tsx';

const EditCampaign = () => {
  const { id } = useParams();
  return <CampaignForm mode="edit" id={id || ''} />;
};

export default EditCampaign;

